// pages/profile/ProfilePage.tsx
"use client";

import { useRecoilState } from "recoil";
import { useRecoilValue } from "recoil";
import { authState } from "@/atoms/auth";
import { fetchProfile, profileState } from "@/atoms/profile";
import { useEffect, useMemo, useState } from "react";
import { DataMinerForm } from "@/components/forms/DataMinerForm";
import PageWrapper from "@/components/layout/PageWrapper";
import Loading from "@/components/LoadingSplashScreen";
import { useExchangeRateToUSD } from "@/hooks/useExchangeRateToUSD";
import { currenciesState } from "@/atoms/exchangeRate";
import { useTransactions } from "@/hooks/useTransactions";

export default function ProfilePage() {
  const [auth] = useRecoilState(authState);
  const [profile, setProfile] = useRecoilState(profileState);
  const [loading, setLoading] = useState<boolean>(true);
  const currencies = useRecoilValue(currenciesState);
  const getExchangeRateToUSD = useExchangeRateToUSD(currencies || []);
  const transactions = useTransactions();

  useEffect(() => {
    if (!auth) {
      return;
    }

    async function loadProfile(k: string) {
      const profile = await fetchProfile(k);
      setProfile(profile || null);
      setLoading(false);
    }

    loadProfile(auth.key);
  }, [auth, setProfile, setLoading]);

  const totalIncome = useMemo(() => {
    return transactions
      .filter((transaction) => transaction.transaction_type === "income")
      .reduce((sum, transaction) => {
        return sum + Math.abs((transaction.amount_cents / 100));
      }, 0) || 0;
  }, [transactions, getExchangeRateToUSD]);

  const totalExpense = useMemo(() => {
    return transactions
      .filter((transaction) => transaction.transaction_type === "expense")
      .reduce((sum, transaction) => {
        return sum + Math.abs((transaction.amount_cents / 100));
      }, 0) || 0;
  }, [transactions, getExchangeRateToUSD]);

  if (loading) {
    return <Loading />;
  }

  return (
    <PageWrapper>
      <DataMinerForm
        totalIncome={totalIncome}
        totalExpense={totalExpense}
        selectedCurrency={profile?.currency || "USD"}
        setSelectedCurrency={() => { }}
        currencies={currencies}
      />
    </PageWrapper>
  );
}